export * from './lib/button.component.module';

export { ButtonSize, ButtonColor, ButtonType } from './lib/button.component';
